























































































































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import TLogin from "@/components/template/Login.vue";
import Textbox from "@/components/atoms/Textbox.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { IAlertInfo } from "@/types";
import Modal from "@/components/atoms/Modal.vue";
import ChangePassword from "@/components/molecules/ChangePassword.vue";
import * as CONSTANTS from "@/common/constants";
import { Auth } from "aws-amplify";
import { OperationLogsStore } from "@/store";
import { OperationLogs } from "@/store/modules/operationLogs";
import Utils from "@/common/utils";

@Component({
  components: { TLogin, Textbox, AlertMessage, Modal, ChangePassword },
})
export default class PasswordReset extends Vue {
  name: "PasswordReset";
  private isShowResetPassword = false;
  private userId = "";
  private dangerAlertList: IAlertInfo[] = [];

  @Watch("isShowResetPassword")
  onChanged() {
    // this.userId = "";
    this.dangerAlertList = [];
  }

  get panelTitle() {
    return this.isShowResetPassword
      ? "パスワード変更"
      : "セキュリティコード送信";
  }

  get completedModalId() {
    return "completedModalId";
  }

  private transitionToLogin() {
    this.$router.push({
      name: CONSTANTS.ROUTE_NAME.LOGIN,
    });
  }

  /*
   * セキュリティコード送信画面
   */

  private async onClickSendSecurityCode(): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await Auth.forgotPassword(this.userId);
      this.$bvModal.show(this.completedModalId);
    } catch (e: any) {
      console.error(e);
      if (e && e.message) {
        let mes = Utils.getErrorMessageByErrorCodeWithoutDefaultError(
          String(e.message)
        );
        if (mes) {
          this.dangerAlertList.push({
            item: "AMPLIFY",
            message: mes,
          });
          return;
        }
      }
      this.dangerAlertList.push({
        item: "AMPLIFY",
        message: Utils.getErrorMessageByErrorCode("EI002"),
      });
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private transitionToPasswordReset() {
    this.isShowResetPassword = true;
  }

  /*
   * パスワード変更画面
   */
  private async onClickChangePassword(
    securityCode: string,
    currentPassword: string,
    password: string,
    passwordConfirm: string
  ): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      // 確認用パスワードの一致チェック
      if (password !== passwordConfirm) {
        throw new Error("EI004");
      }
      await Auth.forgotPasswordSubmit(this.userId, securityCode, password);
      await OperationLogsStore.recordOperationLogsNonAuth({
        email: this.userId,
        operation_class: OperationLogs.OPERATION_CLASS.PASSWORD_RESET,
      });
      this.$bvModal.show(this.completedModalId);
    } catch (e: any) {
      console.error(e);
      if (e && Array.isArray(e)) {
        e.forEach((error: any) => {
          if (error.item && error.message) {
            this.dangerAlertList.push({
              item: error.item,
              message: error.message,
            });
          }
        });
        return;
      } else if (e && e.message) {
        console.error(e.message);
        let mes = Utils.getErrorMessageByErrorCodeWithoutDefaultError(
          String(e.message)
        );
        if (mes) {
          this.dangerAlertList.push({
            item: "AMPLIFY",
            message: mes,
          });
          return;
        }
      }
      this.dangerAlertList.push({
        item: "AMPLIFY",
        message: Utils.getErrorMessageByErrorCode("EI003"),
      });
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private transitionToSendSecurityCode(): void {
    this.isShowResetPassword = false;
  }

  private clearAlertList(): void {
    this.dangerAlertList = [];
  }
}
